// Vortex Power Solutions — Company Constants

export const COMPANY = {
  name: "Vortex Power Solutions",
  short: "Vortex",
  tagline: "Engineering Reliable Power. Since Day One.",
  description:
    "ISO & CE Certified manufacturer of Servo Voltage Stabilizers, Isolation Transformers, Automatic Phase Sequence Correctors, Automatic Phase Changers and Industrial Automation Products.",
  phone: "+91 73059 55155",
  phone2: "+91 98765 43211",
  whatsapp: "73059 55155",
  email: "sales@vortexworld.in",
  supportEmail: "support@vortexword.in",
  address: {
    line1: "Plot No. 4059, 1st Cross Street",
    line2: "Srinivasa Main Road, Ram Nagar North Extension",
    city: "Madipakkam",
    state: "Chennai",
    zip: "600091",
    country: "India",
  },
  hours: "Mon – Sat · 9:00 AM – 7:00 PM IST",
  founded: "2004",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Products", to: "/products", mega: true },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { label: "Years of Excellence", value: 45, suffix: "+" },
  { label: "Products Delivered", value: 12500, suffix: "+" },
  { label: "Industries Served", value: 25, suffix: "+" },
  { label: "Cities Reached", value: 10, suffix: "+" },
];

export const CERTIFICATIONS = [
  "ISO 9001:2015",
  "CE Certified",
  "Made in India",
  "MSME Registered",
];
